import React, { useEffect } from "react";
import { Layout, Row, Col } from "antd";
import { useDispatch } from "react-redux";

//component
import LayoutHeader from "../00_Nav/layout/layout_header";
import TriggerInit from "./trigger/trigger_init";
//action
import { setHighlight } from "../../store/bailiff/nav/nav.action";
import SupporterLists from "./01_List/supporter_lists";
import DialogAddSupporter from "./dialog/dialog_supporter_add";
import "./style.css";
import DialogSupporterPers from "./dialog/dialog_supporter_pers";

const { Content } = Layout;

const SupporterScreen = () => {
  // -------------------------- VAR --------------------------
  const title = "Nhân viên";

  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(setHighlight(["1"]));
  }, [dispatch]);
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row>
        <Col xl={24} lg={24} md={24} xs={24}>
          {/* Supporter   */}
          <SupporterLists />
        </Col>
      </Row>
    );
  };
  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      <LayoutHeader title={title} />
      <Content className="content">
        <Row justify={"center"} gutter={[0, 30]}>
          <Col xl={12} lg={12} md={22} xs={24}>
            {renderBody()}
          </Col>
        </Row>
        {/* Dialog */}
        <DialogAddSupporter />
        <DialogSupporterPers />
        {/* Trigger */}
        <TriggerInit />
      </Content>
    </Layout>
  );
};

export default SupporterScreen;
